module.exports = __webpack_public_path__ + "img/aParty_111523_H.b94335af.jpg";